export const modelFetchLoadingObjectId = "fetchingModelGltfFile";
